// Pengiraan yuran dari invois + bayaran (client-side, dari data RLS)
export function paidByInvoice(payments = []) {
  const map = {};
  for (const p of payments) {
    if (p.voided) continue;
    map[p.invoice_id] = (map[p.invoice_id] || 0) + Number(p.jumlah_rm || 0);
  }
  return map;
}

export function invoiceOutstanding(inv, paidMap) {
  return Math.max(0, Number(inv.jumlah_bayar_rm || 0) - (paidMap[inv.id] || 0));
}

export function studentSummary(invoices = [], paidMap = {}) {
  let outstanding = 0, billed = 0, paid = 0;
  for (const inv of invoices) {
    billed += Number(inv.jumlah_bayar_rm || 0);
    paid += paidMap[inv.id] || 0;
    outstanding += invoiceOutstanding(inv, paidMap);
  }
  let status = 'lunas';
  if (outstanding > 0) status = paid > 0 ? 'separa' : 'belum';
  return { outstanding, billed, paid, status, count: invoices.length };
}

export function groupBy(arr, key) {
  return arr.reduce((acc, x) => {
    (acc[x[key]] = acc[x[key]] || []).push(x);
    return acc;
  }, {});
}
